import type { PlanStatus } from '@vy/types';
import { PLAN_STATUSES } from '@vy/types';
import { values } from '@vy/utils';
import { FilterContainer } from '../../../../../../components/new-design/table/vy-table-toolbar/vy-table-toolbar-components/FiltersContainer';
import { usePageParam } from '../../../../../../hooks/search-params/use-page-param';
import { FilterSelect } from '../../../../../../pages/invoices/InvoicesPage/invoices-page-components/InvoiceFilter/FilterSelect';
import { usePlansOverviewsStatusesParam } from '../../hooks/use-plans-overviews-statuses-param';

export const PlanFilters: React.FC<{ isOpen: boolean }> = ({ isOpen }) => {
  const [selectedPlansOverviewsStatuses, setSelectedPlansOverviewsStatuses] =
    usePlansOverviewsStatusesParam();
  const [_page, setPage] = usePageParam();

  const resetFilters = () => {
    setSelectedPlansOverviewsStatuses([PLAN_STATUSES.Active]);
    setPage(0);
  };

  return (
    <FilterContainer isOpen={isOpen} onReset={resetFilters}>
      <FilterSelect<PlanStatus>
        label="Status"
        options={values(PLAN_STATUSES)}
        selectedValues={selectedPlansOverviewsStatuses ?? []}
        setSelectedValues={setSelectedPlansOverviewsStatuses}
        getLabel={(status) => status}
      />
    </FilterContainer>
  );
};
